// Generated with util/create-component.js
import React, { useState, useRef, useEffect } from 'react'
import { motion } from 'framer-motion'
import { PopupProps } from './Popup.types'
import merge from 'lodash/merge'

import Portal from '../Portal/Portal'
import Visible from '../Visible/Visible'

const Popup: React.FC<PopupProps> = ({
    align = 'left',
    pos = 'bottom',
    offset = 10,
    show = false,
    anchor,
    children,
    width,
    height,
    background,
    color,
    positioning = [],
    maxHeight = '500px',
    wrapperStyle = {},
    bodyStyle = {},
    onHide = () => {},
    className = '',
    showIndicator = false,
}: PopupProps) => {
    const motionOffset = -20
    const spacingOffset = 8
    const [x, setX] = useState(0)
    const [y, setY] = useState(0)
    const [_height, setHeight] = useState(0)
    const [_width, setWidth] = useState(0)
    const [anchorWidth, setAnchorWidth] = useState(0)
    const [anchorHeight, setAnchorHeight] = useState(0)
    const [isOverflowing, setIsOverFlowing] = useState(false)
    const [internalPosition, setInternalPosition] = useState(pos)
    const [internalAlign, setInternalAlign] = useState(align)
    const [tempPos, setTempPos] = useState(null)
    const [nodePos, setNodePos] = useState(null)
    const node = useRef(null)

    useEffect(() => {
        if (show) {
            calculatePosition()
        }
        // todo: clean up event listenr on unmount
        window.addEventListener('scroll', (e) => {
            calculatePosition()
        })
        window.addEventListener('resize', (e) => {
            calculatePosition()
        })
    }, [show, tempPos])

    const getX = (_anchor, _node) => {
        const anchor = _anchor.getBoundingClientRect()
        const node = _node.getBoundingClientRect()
        const windowMinX = 0
        const windowMaxX = window.innerWidth
        const anchorXCenter = anchor.left + anchor.width / 2
        const anchorXRight = anchor.left + anchor.width
        let xPos = 0
        setAnchorWidth(anchor.width)
        setWidth(node.width)
        //Position Right
        if (pos === 'right') {
            xPos = anchor.left + anchor.width + offset
        }

        //Position Bottom
        if (pos === 'bottom') {
            if (internalAlign === 'left') {
                xPos = anchor.left
            } else if (internalAlign === 'middle') {
                xPos = anchorXCenter - node.width / 2
            } else if (internalAlign === 'right') {
                xPos = anchorXRight - node.width
                // anchorPos.top
            }
            // xPos = anchorPos.left + anchorPos.width + offset
        }

        if (xPos < windowMinX) {
            xPos = windowMinX
        }

        //Node is wider than window. Set the node to align to the right of the anchor
        if (xPos + node.width > windowMaxX) {
            xPos = anchorXRight - node.width
        }
        return xPos
    }
    const calculatePosition = () => {
        const _anchor = anchor.current
        const contents = node.current
        if (!_anchor || !contents) {
            return
        }

        const anchorPos = _anchor.getBoundingClientRect()
        const anchorHeight = anchorPos.height
        const nodePos = contents.getBoundingClientRect()
        const nodeWidth = nodePos.width
        const nodeHeight = nodePos.height
        const anchorXCenter = anchorPos.left + anchorPos.width / 2
        const anchorYTop = anchorPos.y
        const anchorYMiddle = anchorYTop + anchorHeight / 2
        const anchorYBottom = anchorYTop + anchorHeight

        let xPos = getX(anchor.current, node.current)

        const _pos = tempPos || pos

        // let xPos = anchorPos.left + anchorPos.width / 2 - nodePos.width / 2
        let yPos = anchorPos.top

        if (align === 'left') {
            // xPos = anchorPos.left
        }
        let xPositiong = null
        let yPositiong = null

        if (positioning[0] === 0) {
            xPositiong = 'left'
        }
        if (positioning[0] === 1) {
            xPositiong = 'middle'
        }
        if (positioning[0] === 2) {
            xPositiong = 'right'
        }
        if (positioning[1] === 0) {
            yPositiong = 'top'
        }
        if (positioning[1] === 1) {
            yPositiong = 'middle'
        }
        if (positioning[1] === 2) {
            yPositiong = 'bottom'
        }

        // if (xPos < 5) {
        //     xPos = 5
        // }
        console.log('PTOSITP', xPositiong, yPositiong)
        //Position Right
        if (yPositiong === 'top' || _pos === 'top') {
            yPos = anchorPos.y - nodeHeight - 10
            // xPos = anchorPos.left + anchorPos.width + offset
            // yPos = anchorPos.top

            // if (align === 'middle') {
            //     yPos = anchorYMiddle - nodeHeight / 2
            // }
            // debugger
        }
        if (xPositiong === 'right' || _pos === 'right') {
            // xPos = anchorPos.left + anchorPos.width + offset
            yPos = anchorPos.top

            if (align === 'middle') {
                yPos = anchorYMiddle - nodeHeight / 2
            }
        }
        if (xPositiong === 'left' || _pos === 'left') {
            xPos = anchorPos.left
        }

        //Position Right
        if (yPositiong === 'bottom' || _pos === 'bottom') {
            yPos = anchorPos.top + anchorHeight + offset
            if (align === 'left') {
                // xPos = anchorPos.left
            } else if (align === 'middle') {
                // xPos = anchorXCenter - nodeWidth / 2
            } else {
                // anchorPos.top
            }
            // xPos = anchorPos.left + anchorPos.width + offset
        }
        setAnchorHeight(anchorPos.height)
        setX(xPos)
        setY(yPos)
    }

    const checkOverflow = () => {
        if (node.current) {
            const nodePos = node.current.getBoundingClientRect()

            if (pos === 'bottom') {
                const _isOverFlowing = nodePos.y + nodePos.height >= window.innerHeight
                if (_isOverFlowing) {
                    setTempPos('top')
                    setHeight(window.innerHeight - nodePos.y - 15)
                }
            }
            // const _height = nodePos.height
            // setIsOverFlowing(_isOverFlowing)
            // debugger
        }
    }

    useEffect(() => {
        checkOverflow()
    }, [x, y])

    const _wrapperStyle = {
        width: width || 'auto',
        position: 'fixed',
        top: y + 'px',
        left: x + 'px',
        opacity: 0,
    } as React.CSSProperties

    const _bodyStyle = {
        maxHeight,
        height: _height ? _height + 'px' : 'auto',
        boxShadow: 'rgb(67 90 111 / 22%) 0px 5px 18px -1px',
        zIndex: 100001,
        background,
        color,
    } as React.CSSProperties

    const indicatorWidth = 15

    let indicatorLeft = 0

    if (align === 'middle') {
        const anchorLeft = anchor?.current?.getBoundingClientRect().x ?? 0
        indicatorLeft = anchorLeft - x + anchorWidth / 2 - indicatorWidth / 2
    }
    if (align === 'right') {
        indicatorLeft = _width - anchorWidth / 2 - indicatorWidth / 2
    }
    if (align === 'left') {
        indicatorLeft = anchorWidth / 2 - indicatorWidth / 2
    }

    const _indicatorStyle = {
        left: indicatorLeft + 'px',
        width: indicatorWidth + 'px',
        height: indicatorWidth + 'px',
        background,
    }

    if (!show) {
        return null
    }

    return (
        <Portal container={document.body} onUnmount={onHide}>
            <motion.div
                data-testid={'Popup'}
                animate={{ opacity: 1, y: 0 + 'px' }}
                ref={node}
                style={merge(_wrapperStyle, wrapperStyle)}
                className={`r-popup`}
            >
                {tempPos}
                <Visible visible={showIndicator}>
                    <div style={_indicatorStyle} className={'r-popup-indicator'} />
                </Visible>
                <div className={`r-popup-contents ${className}`} style={merge(_bodyStyle, bodyStyle)}>
                    {children}
                </div>
            </motion.div>
        </Portal>
    )
}

export default Popup
